'use client';

import styled from 'styled-components';

export const TermsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TermsText = styled.p`
  color: ${({ theme }) => theme.colors.typographyHeadersLight};
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  font-weight: ${({ theme }) => theme.typography.body.fontWeight};
  line-height: ${({ theme }) => theme.typography.body.lineHeight};
`;

export const ArticleTitle = styled.h1`
  color: ${({ theme }) => theme.colors.typographyHeadersLight};
  font-size: ${({ theme }) => theme.typography.title.fontSize};
  font-weight: ${({ theme }) => theme.typography.title.fontWeight};
  line-height: ${({ theme }) => theme.typography.title.lineHeight};
`;
